"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compatible = void 0;
exports.compatible = {
    chrome: '85',
    edge: '85',
    firefox: '90',
    safari: '14',
    ios: '14',
};
exports.default = Object.entries(exports.compatible).map(([b, v]) => `${b} >= ${v}`);
//# sourceMappingURL=compatible.js.map